//SEE https://www.ibm.com/docs/en/datacap/9.1.8?topic=support-supported-language-codes

const languages = [ 
    {name: 'English', value: 'en-UK'},
    {name: 'Français', value: 'fr-FR'}, 
    {name: 'Español', value: 'es-ES'}, 
    {name: 'Deutsch', value: 'de-DE'}, 
  ];

  export default languages;